<template>
  <div class="content">
    <div class="control_bar top">
      <div class="search">
        {{ title }}
      </div>
      <div class="controller">
        <ul class="action_buttons">
          <li class="column_add action_button">
            <router-link :to="router" class="add_router">
              {{ addButton }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <td class="table_no">
            <label>{{ noLabel }}</label>
          </td>
          <td class="table_date">
            <label>{{ startDatetimeLabel }}</label>
          </td>
          <td class="table_date">
            <label>{{ endDatetimeLabel }}</label>
          </td>
          <td class="table_contents">
            <label>{{ titleLabel }}</label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="(notification, index) in formatDateList"
            :key="notification.notificationId"
          >
            <td class="table_no" @click="toDetail(notification.notificationId)">
              <label>{{ index + 1 + (page - 1) * 20 }}</label>
            </td>
            <td
              class="table_date"
              @click="toDetail(notification.notificationId)"
            >
              <label>{{ notification.startDateTime }}</label>
            </td>
            <td
              class="table_date"
              @click="toDetail(notification.notificationId)"
            >
              <label>{{ notification.endDateTime }}</label>
            </td>
            <td
              class="table_contents"
              @click="toDetail(notification.notificationId)"
            >
              <div class="title">{{ notification.title }}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setNotifications(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFailureModal">
      <failureModalWindow :question="failureWord" @close="close">
      </failureModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import failureModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      title: 'お知らせ',
      addButton: '追加',
      noLabel: 'No.',
      startDatetimeLabel: '開始日時',
      endDatetimeLabel: '終了日時',
      titleLabel: 'タイトル',
      router: '/master/notification/add',
      failureWord: '',
      showFailureModal: false,
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0
    }
  },
  computed: {
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.notifications.total
      ) {
        return this.$store.state.notifications.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.notifications.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.notifications.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    notificationList() {
      return this.$store.state.notifications.notifications
    },
    formatDateList() {
      var items = []
      for (let notification of this.notificationList) {
        var item = Object()
        item.notificationId = notification.notificationId
        item.title = notification.title
        var s = new Date(notification.startDateTime)
        item.startDateTime =
          s.getFullYear() +
          '/' +
          this.padZero(s.getMonth() + 1) +
          '/' +
          this.padZero(s.getDate()) +
          '  ' +
          this.padZero(s.getHours()) +
          ':' +
          this.padZero(s.getMinutes()) +
          ':' +
          this.padZero(s.getSeconds())
        var e = new Date(notification.endDateTime)
        item.endDateTime =
          e.getFullYear() +
          '/' +
          this.padZero(e.getMonth() + 1) +
          '/' +
          this.padZero(e.getDate()) +
          '  ' +
          this.padZero(e.getHours()) +
          ':' +
          this.padZero(e.getMinutes()) +
          ':' +
          this.padZero(e.getSeconds())
        items.push(item)
      }
      return items
    }
  },
  components: {
    Pagination,
    failureModalWindow,
    loadingModalWindow
  },
  async created() {
    this.$store.dispatch('systemAdminDefine/clearCompanyInfo')
    this.$store.dispatch('notifications/clearAddData')
    this.$store.dispatch('notifications/clearUpdateData')
    this.$store.dispatch('notifications/clearSelectedTenantList')
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.setNotifications(0)
    this.$store.state.notifications.selectAllFlag = false
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    close() {
      this.showFailureModal = false
    },
    async setNotifications(pageNo) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('notifications/setNotifications', {
          pageNo: pageNo
        })
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0106')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async toDetail(notificationId) {
      this.showloadingModal = true
      this.$store.dispatch('notifications/inputUpdate', {
        name: 'notificationId',
        value: notificationId
      })
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        this.$router.push('/master/notification/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670005
        this.createErrorMessage(error, eventNumber, 'MSGCRD0111')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    }
  }
}
</script>
<style scoped>
.control_bar {
  background-color: #bbffff;
}
.bottom {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
}
.table_no {
  width: 3%;
}
.table_date {
  width: 20%;
}
.table_contents {
  width: 57%;
}
.title {
  word-break: break-word;
}
.content_title {
  background-color: #ddffff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/notification/notificationList.vue